import React from 'react';
import Joi from 'joi-browser';
import * as _ from 'lodash';
import { validationByJoi } from '../utilities/commonValidation';
import slideLoader from '../utilities/slideLoader';
import dialogLoader from '../utilities/dialogLoader';
import EventMg from '../utilities/EventManager';
import { HEADER_CONSTANTS } from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility';
import { CRANE_TYPES } from '../utilities/constants';
import { isApiFlagOn } from '../utilities/commonUtil.js';
import { CraneService } from '../services/Cranes';
import { FieldImageService } from '../services/FieldImages';
import { FieldMasters } from '../services/FieldMasters.js';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { Delete } from './modals/Commons';
import * as dialog from '../components/FieldTreeDialog';
import { CloseEditView } from '../components/CloseEditView';
import { Modal } from '../components/Modal';
import { DialogSuccessError } from '../components/modals/DialogSuccessError';
import { FieldImagesKeyplanMasterDropdown } from '../components/dropdowns/single/FieldImagesKeyplanMaster';
import Helmet from 'react-helmet';
import {
  getErrorMessage,
  CO2Form,
  convertDate,
  RequiredCountComponent,
  getRequiredColumns,
  convertSchema,
  MASTER_TYPE,
  CO2_FORM_VALUES,
  OTHER_VALUE,
  CO2_REQUIRED_COLUMNS,
  CO2_DROPDOWN_NAME_COLUMNS,
  isAfterDate,
} from './common/MasterParts.jsx';
import {
  deleteControlCode,
  trimAndRemoveLineBreak,
} from '../utilities/stringUtil';
import { ConferencePageHeader } from '../components/PageHeader';
import {
  FormElement,
  FormList,
  FormListItem,
} from '../components/CommonFormComponents';
import { ArrowDownIcon } from '../components/icons/ArrowDownIcon';
import { RadioButtonIcon } from '../components/icons/RadioButtonIcon';

const MY_EVENT = {
  LOAD_CRANES: 'load_cranes', // 一覧取得
};

/**
 * @description 揚重機編集画面
 */
export class CranesEdit extends React.Component {
  constructor(props) {
    super(props);

    // 必須項目のキー配列
    const co2ReportFlag = SessionStorageService.getCo2ReportFlag();

    // 第2引数はCO2があるかどうか
    const columns = getRequiredColumns(MASTER_TYPE.CRANE, co2ReportFlag);

    this.state = {
      // 鹿島が元請け、かつメインの現場だけCO2の項目を表示
      showCO2Form: co2ReportFlag,
      fieldId: SessionStorageService.getFieldId(),
      craneId: props.view.state.id,
      formValues: {
        display_flag: '',
        type: '',
        name: '',
        spec_form: '',
        partner_company_name: '',
        field_image_category_code: null,
        memo: '',
        image_url: '',
        created_at: '',
        updated_at: '',
      },
      isUseTansomiru: false,
      errors: {},
      isEdit: true,
      requiredInput: {
        columns,
        count: 4,
      },
      isLoading: false, //「削除」ボタンの連打防止Flag
    };

    this.events = {
      modal: {
        deleteModal: this.deleteModal.bind(this),
        delete: this.deleteCrane.bind(this),
        openCloseEditModal: this.openCloseEditModal.bind(this),
      },
      form: {
        keyplan: this.setDropdownKeyplanData.bind(this), // キープラン選択
      },
    };

    const uid = _.uniqueId();
    this.targetId = `infinityscroll-target-field-image-keyplan-${uid}`;
    this.updateCrane = this.updateCrane.bind(this);
    this.deleteModal = this.deleteModal.bind(this);
    this.craneList = this.craneList.bind(this);
    this.onChangeFormValues = this.onChangeFormValues.bind(this);
    this.onRadioChange = this.onRadioChange.bind(this);
    this.validate = this.validate.bind(this);

    this.BASE_SCHEMA = Joi.object().keys({
      id: Joi.allow(),
      type: Joi.number()
        .empty('')
        .required(),
      display_flag: Joi.number().required(),
      name: Joi.string()
        .max(255)
        .required(),
      spec_form: Joi.string()
        .max(127)
        .required(),
      partner_company_name: Joi.string()
        .max(255)
        .required(),
      field_image_category_code: Joi.number()
        .allow(null)
        .optional(),
      memo: Joi.string()
        .max(500)
        .allow('')
        .optional(),
      image_url: Joi.string()
        .max(500)
        .allow('')
        .optional(),
      created_at: Joi.allow(),
      updated_at: Joi.allow(),
    });

    this.schema = this.BASE_SCHEMA;
    this.isRequestingFlag = false;
  }

  componentDidMount() {
    // APIで既存の編集内容取得
    this.getEditingCrane();
  }

  /**
   * 「その他」の変化
   *
   * @param {array} requiredColums
   * @memberof CranesEdit
   */
  changeRequiredInput(requiredColums) {
    // 必須キーの変化
    const columns = getRequiredColumns(MASTER_TYPE.CRANE, true, requiredColums);
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    requiredInput.columns = columns;

    // schema更新
    this.schema = convertSchema(this.BASE_SCHEMA, requiredColums);

    // 「その他機材名」がなくなったのに「必須です。」が出てしまう対策

    this.setState(
      {
        requiredInput,
      },
      () => {
        this.onChangeCount();
      }
    );
  }

  /**
   * @description 入力値設定
   * @param {*} event
   */
  onChangeFormValues(event) {
    const formValues = _.cloneDeep(this.state.formValues);
    const targetName = event.target.name;
    const targetValue = event.target.value;
    formValues[targetName] = deleteControlCode(targetValue);
    let co2RequiredColumns = [];
    // 「仕様分類」が決まった時に、「その他」なら「その他機材名」を有効にする
    if (this.state.showCO2Form) {
      // 上から順に選択したものをリセットすることが必要
      if (targetName === 'middle_machine_id') {
        formValues.middle_machine_name = event.target.valueName;
        // nullではなく''でリセット
        formValues.small_machine_id = '';
        formValues.spec_id = '';
        formValues.machine_fuel_id = '';
        formValues.small_machine_name = '';
        formValues.spec_name = '';
        formValues.machine_fuel_name = '';

        if (targetValue === OTHER_VALUE) {
          formValues.small_machine_id = OTHER_VALUE;
          formValues.spec_id = OTHER_VALUE;
          co2RequiredColumns = [
            'ownership',
            'co2_calculation_method',
            'middle_machine_id',
            'other_name',
          ];
          this.state.isUseTansomiru &&
            co2RequiredColumns.push('machine_fuel_id');
        } else {
          formValues.other_name = '';
          co2RequiredColumns = [
            'ownership',
            'co2_calculation_method',
            'middle_machine_id',
          ];
          targetValue !== '' && co2RequiredColumns.push('small_machine_id');
        }
      }

      if (targetName === 'small_machine_id') {
        formValues.small_machine_name = event.target.valueName;
        // nullではなく''でリセット
        formValues.spec_id = '';
        formValues.machine_fuel_id = '';
        formValues.spec_name = '';
        formValues.machine_fuel_name = '';
        if (targetValue === OTHER_VALUE) {
          formValues.spec_id = OTHER_VALUE;
          co2RequiredColumns = [
            'ownership',
            'co2_calculation_method',
            'middle_machine_id',
            'small_machine_id',
            'other_name',
          ];
          this.state.isUseTansomiru &&
            co2RequiredColumns.push('machine_fuel_id');
        } else {
          formValues.other_name = '';
          co2RequiredColumns = [
            'ownership',
            'co2_calculation_method',
            'middle_machine_id',
            'small_machine_id',
          ];
          targetValue !== '' && co2RequiredColumns.push('spec_id');
        }
      }

      if (targetName === 'spec_id') {
        formValues.spec_name = event.target.valueName;
        // nullではなく''でリセット
        formValues.machine_fuel_id = '';
        formValues.machine_fuel_name = '';
        if (targetValue === OTHER_VALUE) {
          co2RequiredColumns = [
            'ownership',
            'co2_calculation_method',
            'middle_machine_id',
            'small_machine_id',
            'spec_id',
            'other_name',
          ];
        } else {
          formValues.other_name = '';
          co2RequiredColumns = [
            'ownership',
            'co2_calculation_method',
            'middle_machine_id',
            'small_machine_id',
            'spec_id',
          ];
        }
        targetValue !== '' &&
          this.state.isUseTansomiru &&
          co2RequiredColumns.push('machine_fuel_id');
      }

      if (targetName === 'machine_fuel_id') {
        formValues.machine_fuel_name = event.target.valueName;
      }
      ['middle_machine_id', 'small_machine_id', 'spec_id'].includes(
        targetName
      ) && this.changeRequiredInput(co2RequiredColumns);
      this.validate(event, formValues);
    }
    this.setState({ formValues });
  }

  /**
   * 必須項目の入力数カウント
   *
   * @memberof CranesEdit
   */
  onChangeCount() {
    const formValues = _.cloneDeep(this.state.formValues);
    let cnt = 0;
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    const errors = _.cloneDeep(this.state.errors);
    _.each(requiredInput.columns, column => {
      if (
        !errors[column] &&
        (column === 'co2_calculation_method'
          ? !_.isNil(formValues[column])
          : formValues[column])
      ) {
        cnt++;
      }
    });

    requiredInput.count = cnt;
    this.setState({ requiredInput });
  }

  /**
   * 燃料購入元のラジオボタンの処理
   *
   * @param {number} index 0 or 1
   * @param {string} name ownership(燃料購入元のキー)
   * @param {number} value ラジオボタンのvalue, 1 or 2
   * @memberof CranesEdit
   */
  onRadioChange(index, name, value) {
    const formValues = _.cloneDeep(this.state.formValues);
    formValues[name] = value;

    this.setState({
      formValues,
    });
  }

  /**
   * 重複チェック
   *
   * @param {*} name
   * @param {*} errors
   * @returns
   * @memberof CranesEdit
   */
  duplicateCheck(name, errors) {
    return CraneService.list(this.state.fieldId, { is_limit: 0 }).then(resp => {
      if (resp.result) {
        const listData = resp.data.entities.cranes;
        const names = _.map(listData, crane => crane.name);
        // 自身の名前とのチェック(Editの場合のみ)
        if (this.state.validateName !== this.state.formValues.name) {
          if (_.some(names, n => n === name)) {
            errors.name = messageUtility.getMessage('E-001-005');
          }
        }

        this.setState({ errors }, this.onChangeCount);
      }
    });
  }

  /**
   * バリデーション
   *
   * @param {Event} event Event
   * @param {*} formValues 即時にチェックしたい時だけは引数として渡す
   * @returns
   * @memberof CranesEdit
   */
  validate(event, formValues = this.state.formValues) {
    const params = _.cloneDeep(formValues);
    const result = validationByJoi(this.schema, params);
    const errors = _.cloneDeep(this.state.errors);
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    _.each(CO2_REQUIRED_COLUMNS, item => {
      !requiredInput.columns.includes(item) && delete errors[item];
    });
    // 単数or複数判定
    if (event) {
      if (result.messages[event.target.name]) {
        errors[event.target.name] = result.messages[event.target.name];
      } else if (errors[event.target.name]) {
        delete errors[event.target.name];
      }

      if (event.target.name === 'name') {
        this.duplicateCheck(trimAndRemoveLineBreak(event.target.value), errors);
      } else {
        this.setState({ errors }, this.onChangeCount);
      }

      return Object.keys(this.state.errors).length;
    } else {
      // 非同期処理が終わってから返す
      return this.duplicateCheck(
        trimAndRemoveLineBreak(params.name),
        result.messages
      ).then(() => {
        return Object.keys(this.state.errors).length;
      });
    }
  }

  handleBlur = event => {
    event.persist();
    const { name, value } = event.target;
    const formValues = _.cloneDeep(this.state.formValues);
    formValues[name] = trimAndRemoveLineBreak(value);
    this.setState({ formValues }, () => this.validate(event));
  };

  /**
   * 更新処理
   *
   * @memberof CranesEdit
   */
  updateCrane() {
    if (this.isRequestingFlag) {
      return;
    }
    this.isRequestingFlag = true;
    this.validate().then(validate => {
      if (validate !== 0) {
        this.isRequestingFlag = false;
        return;
      }
      const fieldId = this.state.fieldId;
      const id = this.state.craneId;
      let params = _.cloneDeep(this.state.formValues);

      if (!this.state.isUseTansomiru) {
        params.machine_fuel_id = null;
      }
      CraneService.update(fieldId, id, params)
        .then(resp => {
          if (resp.result) {
            const jumpTo = () => {
              this.setState({ showModal: false });
              this.craneList();
            };

            // モーダルの表示(更新しました)
            this.setState({
              showModal: true,
              updateSuccess: true,
              updateMsg: messageUtility.getMessage('I-000-003'),
              jumpTo,
            });
          } else {
            const updateMsg = _.has(resp, 'data.message')
              ? resp.data.message
              : messageUtility.getMessage('E-000-005');
            // 失敗時
            this.setState({
              showModal: true,
              updateSuccess: false,
              updateMsg,
            });
          }
        })
        .finally(() => {
          this.isRequestingFlag = false;
        });
    });
  }

  /**
   * 揚重機の取得(API)
   *
   * @memberof CranesEdit
   */
  getEditingCrane() {
    const fieldId = this.state.fieldId;
    const id = this.state.craneId;

    CraneService.show(fieldId, id).then(resp => {
      if (resp.result) {
        const crane = resp.data.entities.crane;
        const image = _.defaultTo(resp.data.entities.field_image, '');
        const machineLink = resp.data.entities.machine_link;

        // キープランの取得API
        this.getEditingKeyplan(crane, image, machineLink);
      }
    });
  }

  /**
   * キープランの取得(API)
   *
   * @param {object} crane
   * @param {object} image 画像
   * @param {object} machineLink CO2情報
   * @memberof CranesEdit
   */
  getEditingKeyplan(crane, image, machineLink) {
    const fieldId = this.state.fieldId;
    const param = {
      category_code: crane.field_image_category_code,
    };

    FieldImageService.list(fieldId, param).then(async resp => {
      if (resp.result) {
        const formValues = {
          display_flag: crane.display_flag,
          type: crane.type,
          name: trimAndRemoveLineBreak(crane.name),
          spec_form: trimAndRemoveLineBreak(crane.spec_form),
          partner_company_name: trimAndRemoveLineBreak(
            crane.partner_company_name
          ),
          field_image_category_code: crane.field_image_category_code,
          memo: crane.memo,
          image_url: image.image_url,
          created_at: crane.created_at,
          updated_at: crane.updated_at,
        };
        let isUseTansomiru = false;

        // CO2の時の特別データ
        if (this.state.showCO2Form) {
          const responseFuelData = await FieldMasters.getMachineFuelsList({
            field_id: fieldId,
            limit: 1,
            offset: 0,
          });
          isUseTansomiru = isApiFlagOn(
            _.get(
              responseFuelData,
              'data.entities.use_tansomiru_management_flag'
            )
          );
          // データがない時はデフォルトのCO2
          if (machineLink === null || _.isUndefined(machineLink)) {
            // mergeは破壊的
            _.merge(formValues, CO2_FORM_VALUES);
            this.changeRequiredInput([
              'ownership',
              'middle_machine_id',
              'co2_calculation_method',
            ]);
          } else {
            // CO2項目用追加のformValues
            const myMachineLink = {
              // 燃料購入元
              ownership: machineLink.ownership,
              // CO2排出量の計算方法
              co2_calculation_method: machineLink.co2_calculation_method,
              // その他が選択されたものは"0"なのでString()
              // 機械分類(中)
              middle_machine_id: String(machineLink.middle_machine_id),
              middle_machine_name: machineLink.middle_machine_name,
              // 機械分類(小)
              small_machine_id: String(machineLink.small_machine_id),
              small_machine_name: machineLink.small_machine_name,
              // 仕様分類
              spec_id: String(machineLink.spec_id),
              spec_name: machineLink.spec_name,
              // 油種
              machine_fuel_id: _.toString(machineLink.machine_fuel_id),
              machine_fuel_name: machineLink.machine_fuel_name,
              // その他機材名
              other_name: trimAndRemoveLineBreak(machineLink.other_name),
            };
            _.merge(formValues, myMachineLink);
            const co2RequiredColumns = [];
            const hasOther = myMachineLink.other_name !== '';
            _.each(Object.keys(myMachineLink), key => {
              if (_.includes(CO2_DROPDOWN_NAME_COLUMNS, key)) {
                return;
              }
              if (key === 'co2_calculation_method') {
                co2RequiredColumns.push(key);
              } else if (key === 'machine_fuel_id') {
                isUseTansomiru &&
                  (myMachineLink['middle_machine_name'] === OTHER_VALUE ||
                    myMachineLink['small_machine_id'] === OTHER_VALUE ||
                    (myMachineLink['small_machine_id'] !== '' &&
                      myMachineLink['spec_id'] !== '')) &&
                  co2RequiredColumns.push(key);
              } else {
                String(myMachineLink[key]) !== '' &&
                  String(myMachineLink[key]) !== OTHER_VALUE &&
                  co2RequiredColumns.push(key);
              }
            });
            if (hasOther) {
              _.each(Object.keys(myMachineLink), col => {
                if (myMachineLink[col] === OTHER_VALUE) {
                  co2RequiredColumns.push(col);
                  return false;
                }
              });
            }
            this.changeRequiredInput(co2RequiredColumns);

            if (
              machineLink.updated_at &&
              isAfterDate(machineLink.updated_at, formValues.updated_at)
            ) {
              formValues.updated_at = machineLink.updated_at;
            }
          }
        }

        this.setState({
          formValues,
          validateName: crane.name,
          isUseTansomiru,
        });

        // 変更の数字更新
        this.onChangeCount();
      }
    });
  }

  /**
   * キープラン選択
   * @param value {object}
   */
  setDropdownKeyplanData = value => {
    const formValues = _.cloneDeep(this.state.formValues);
    formValues.field_image_category_code = value.category_code;
    formValues.image_url = value.image_url;
    this.setState({
      formValues,
    });
  };

  /**
   * 削除モーダル
   *
   * @memberof CranesEdit
   */
  deleteModal() {
    dialogLoader.show(Delete, {
      state: {
        deleteId: this.state.craneId,
        callbacks: this.events,
      },
    });
  }

  /**
   * 揚重機の削除
   *
   * @memberof CranesEdit
   */
  deleteCrane() {
    // BLDE_V2-50769: isLoadingがTrueならdeleteGateが発生しないため、連打防止
    if (!this.state.isLoading) {
      this.setState({ isLoading: true }, () => {
        CraneService.del(this.state.fieldId, this.state.craneId)
          .then(resp => {
            if (resp.result) {
              this.craneList();
              dialogLoader.close();
            } else {
              dialogLoader.show(dialog.NeverDeletePartnerCompany, {
                callback: {
                  done: () => {
                    dialogLoader.close();
                  },
                },
              });
            }
          })
          .finally(() => {
            // 削除が終わったら連打禁止を解除
            this.setState({ isLoading: false });
          });
      });
    }
  }

  /**
   * 右上のXボタンでモーダルを開く
   *
   * @memberof CranesEdit
   */
  openCloseEditModal() {
    dialogLoader.show(CloseEditView, {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          dialogLoader.close();
          EventMg.trigger(MY_EVENT.LOAD_CRANES);
          slideLoader.close(this.props.vw);
        },
      },
    });
  }

  /**
   * 揚重機の一覧へ遷移
   *
   * @memberof CranesEdit
   */
  craneList() {
    EventMg.trigger(MY_EVENT.LOAD_CRANES);
    slideLoader.close(this.props.vw);
  }

  render() {
    return (
      <div className='slide-view show'>
        <div className='slide-view__view'>
          <Helmet>
            <title>{HEADER_CONSTANTS.conference} - 揚重機編集</title>
          </Helmet>
          <ConferencePageHeader
            title={'揚重機編集'}
            onClose={this.events.modal.openCloseEditModal}
          />
          <div className='main__body main__body__new-slide main__body__new-slide--fixed'>
            <div id='setting-header' className='setting-header'>
              <div className='setting-header__item'>
                <button className='btn--effective' onClick={this.updateCrane}>
                  更新
                </button>
                <button className='btn--negative' onClick={this.deleteModal}>
                  削除
                </button>
                <div className='--fx-auto' />
                {/* 必須項目の入力数 */}
                <RequiredCountComponent
                  requiredInput={this.state.requiredInput}
                />
                {/* 右上のXボタン */}
              </div>
            </div>
            <div className='setting-main__table set-width-dropdown'>
              <FormList isSpace={true}>
                <FormListItem label='ステータス'>
                  <FormElement>
                    <div className='form-list-radio'>
                      <div className='form-list-radio__item'>
                        <label className='radio'>
                          <input
                            type='radio'
                            name='display_flag'
                            value='1'
                            checked={
                              parseInt(this.state.formValues.display_flag) === 1
                            }
                            onChange={event => this.onChangeFormValues(event)}
                          />
                          <RadioButtonIcon className='icon--2x' />
                          <span>使用中</span>
                        </label>
                      </div>
                      <div className='form-list-radio__item'>
                        <label className='radio'>
                          <input
                            type='radio'
                            name='display_flag'
                            value='0'
                            checked={
                              parseInt(this.state.formValues.display_flag) === 0
                            }
                            onChange={event => this.onChangeFormValues(event)}
                          />
                          <RadioButtonIcon className='icon--2x' />
                          <span>未使用</span>
                        </label>
                      </div>
                    </div>
                  </FormElement>
                </FormListItem>
                <FormListItem label='クレーン種別' required={true}>
                  <FormElement
                    validate={getErrorMessage(this.state.errors, 'type')}
                  >
                    <select
                      name='type'
                      value={this.state.formValues.type}
                      onChange={event => this.onChangeFormValues(event)}
                      onBlur={event => this.validate(event)} // バリデーション
                    >
                      {_.map(CRANE_TYPES, type => (
                        <option key={type.id} value={type.id}>
                          {type.name}
                        </option>
                      ))}
                    </select>
                    <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
                  </FormElement>
                </FormListItem>
                <FormListItem label='揚重機名' required={true}>
                  <FormElement
                    validate={getErrorMessage(this.state.errors, 'name')}
                  >
                    <input
                      type='text'
                      name='name'
                      maxLength={255}
                      value={this.state.formValues.name}
                      onChange={event => this.onChangeFormValues(event, true)}
                      onBlur={event => this.handleBlur(event)} // バリデーション
                    />
                  </FormElement>
                </FormListItem>
                <FormListItem label='性能' required={true}>
                  <FormElement
                    validate={getErrorMessage(this.state.errors, 'spec_form')}
                  >
                    <input
                      type='text'
                      name='spec_form'
                      value={this.state.formValues.spec_form}
                      maxLength={127}
                      onChange={event => this.onChangeFormValues(event, true)}
                      onBlur={event => this.handleBlur(event)} // バリデーション
                    />
                  </FormElement>
                </FormListItem>
                <FormListItem label='管理会社' required={true}>
                  <FormElement
                    validate={getErrorMessage(
                      this.state.errors,
                      'partner_company_name'
                    )}
                  >
                    <input
                      type='text'
                      name='partner_company_name'
                      maxLength={255}
                      value={this.state.formValues.partner_company_name}
                      onChange={event => this.onChangeFormValues(event, true)}
                      onBlur={event => this.handleBlur(event)} // バリデーション
                    />
                  </FormElement>
                </FormListItem>
                <FormListItem label='指示書用キープラン画像'>
                  <FieldImagesKeyplanMasterDropdown
                    formFlg
                    value={this.state.formValues.field_image_category_code}
                    imageUrl={this.state.formValues.image_url}
                    set={this.events.form.keyplan}
                    onBlur={event => this.validate(event)} // バリデーション
                    error={getErrorMessage(
                      this.state.errors,
                      'field_image_category_code'
                    )}
                  />
                </FormListItem>
                <FormListItem label='備考'>
                  <FormElement
                    validate={getErrorMessage(this.state.errors, 'memo')}
                  >
                    <textarea
                      name='memo'
                      maxLength={500}
                      value={this.state.formValues.memo}
                      onChange={event => this.onChangeFormValues(event, true)}
                      onBlur={event => this.validate(event)} // バリデーション
                    />
                  </FormElement>
                </FormListItem>
                {/* CO2のフォーム */}
                {this.state.showCO2Form && (
                  <CO2Form
                    isEdit={this.state.isEdit}
                    masterType={MASTER_TYPE.CRANE}
                    events={this.events}
                    formValues={this.state.formValues}
                    errors={this.state.errors}
                    onChange={this.onChangeFormValues}
                    onRadioChange={this.onRadioChange}
                    onBlur={this.validate}
                    handleBlurInputText={this.handleBlur}
                    isUseTansomiru={this.state.isUseTansomiru}
                  />
                )}
                <FormListItem label='登録日時'>
                  <FormElement>
                    {convertDate(this.state.formValues.created_at)}
                  </FormElement>
                </FormListItem>
                <FormListItem label='更新日時'>
                  <FormElement>
                    {convertDate(this.state.formValues.updated_at)}
                  </FormElement>
                </FormListItem>
              </FormList>
            </div>
          </div>
          <Modal modalRoot='root' modalState={this.state.showModal}>
            <DialogSuccessError
              msg={this.state.updateMsg}
              updateSuccess={this.state.updateSuccess}
              success={this.state.jumpTo}
              error={() => this.setState({ showModal: false })}
            />
          </Modal>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CranesEdit.jsx